/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const NotificationSettingsResponse = zod.object({
  settings: zod.object({
    showMessagePreviews: zod
      .boolean()
      .describe(
        'Whether out-of-app deliveries (push today) may include message text (\"Andrew messaged you: Hi…\") instead of a content-free line. Default false: push bodies render on locked screens, and a pushed preview can never be redacted after the fact. The in-app notification feed always shows the full text.',
      ),
  }),
});

export type NotificationSettingsResponse = zod.input<typeof NotificationSettingsResponse>;
export type NotificationSettingsResponseOutput = zod.output<typeof NotificationSettingsResponse>;
